import { Icon } from '../icon/icon';
import cls from './chip.module.scss';
type ChipColor =
  | 'green'
  | 'gray'
  | 'orange'
  | 'red'
  | 'blue'
  | 'amber'
  | 'neutral'
  | 'info'
  | 'success';

interface ChipProps {
  color: ChipColor;
  children: React.ReactNode;
  iconPath?: string;
  iconFilter?: string;
  iconSize?: number;
  icon?: React.ReactNode;
  compact?: boolean;
  className?: string;
}

export const Chip: React.FC<ChipProps> = (props: ChipProps) => {
  const {
    color,
    children,
    iconPath,
    iconFilter,
    iconSize = 15,
    icon,
    compact,
    className = '',
  } = props;
  return (
    <div
      className={`${cls.chip} ${cls[color]} ${compact ? cls.compact : ''} ${className}`}
    >
      {icon}
      {!icon && iconPath && (
        <Icon pathToIcon={iconPath} size={iconSize} filter={iconFilter} />
      )}
      {children}
    </div>
  );
};
